import { polynomial as viemPolynomial } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const polynomial = {
  displayName: 'Polynomial',
  runtime: 'evm',
  viemChain: viemPolynomial,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'polynomial' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
